'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$97() {
  this.bq7 = null;
  this.bq8 = false;
}
export { $c_Lpresto_PrestoRouter$$anon$97 as $c_Lpresto_PrestoRouter$$anon$97 };
$p = $c_Lpresto_PrestoRouter$$anon$97.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$97;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$97() {
}
export { $h_Lpresto_PrestoRouter$$anon$97 as $h_Lpresto_PrestoRouter$$anon$97 };
$h_Lpresto_PrestoRouter$$anon$97.prototype = $p;
$p.bW = (function() {
  if ((!this.bq8)) {
    this.bq7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$();
    this.bq8 = true;
  }
  return this.bq7;
});
$p.P = (function() {
  return this.bW();
});
var $d_Lpresto_PrestoRouter$$anon$97 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$97, "presto.PrestoRouter$$anon$97", ({
  P7: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$97 as $d_Lpresto_PrestoRouter$$anon$97 };
//# sourceMappingURL=presto.-Presto-Router$$anon$97.js.map
